import * as moment from 'moment';
import 'moment/locale/de';
import TabletHelper from '../helpers/tabletHelper';
import {
    TABLET_START_SYNC,
    TABLET_RECEIVE_SYNC,
    TABLET_RECEIVE_SYNC_ERROR,
    TABLET_SET_TIME_SLOT,
    TABLET_SET_ROUTE,
    TABLET_SET_SUPPORTER_AVAILABLE,
    TABLET_CHECK_IN_SUPPORTER,
    TABLET_ADD_SUPPORTER_TO_SHIFT
} from "../config/actions";

let defaultState = {
    lastSyncedAt: null,
    lastSyncTry: null,
    syncing: false,
    data: [],
    supporters: [],
    actions: [],
    timeSlot: null,
    route: null,
    supportersAvailable: []
};

const tabletReducer = (state = defaultState, action) => {
    switch (action.type) {
        case(TABLET_START_SYNC):
            return Object.assign({}, state, {
                syncing: true,
                lastSyncTry: moment()
            });
        case(TABLET_RECEIVE_SYNC):
            return Object.assign({}, state, {
                syncing: false,
                lastSyncedAt: moment(),
                data: action.data.routes,
                supporters: action.data.supporters,
                actions: state.actions.filter((el) => !el.sentToServer)
            });
        case(TABLET_RECEIVE_SYNC_ERROR):
            return Object.assign({}, state, {
                syncing: false
            });
        case(TABLET_SET_TIME_SLOT):
            return Object.assign({}, state, {
                timeSlot: action.data
            });
        case(TABLET_SET_ROUTE):
            return Object.assign({}, state, {
                route: action.data
            });
        case(TABLET_SET_SUPPORTER_AVAILABLE):
            TabletHelper.setSupporterAvailable(state.supportersAvailable, action.data.supporter);
            return Object.assign({}, state, {
                supportersAvailable: state.supportersAvailable
            });
        case(TABLET_CHECK_IN_SUPPORTER):
            TabletHelper.checkInSupporter(state.actions, action.data.supporter, action.data.shiftId);
            return Object.assign({}, state, {
                actions: state.actions,
                data: state.data
            });
        case(TABLET_ADD_SUPPORTER_TO_SHIFT):
            TabletHelper.addSupporterToShift(state.actions, state.data, state.supportersAvailable, state.supporters, state.timeSlot, action.supporterId, action.shift);
            return Object.assign({}, state, {
                supportersAvailable: state.supportersAvailable,
                data: state.data
            });
        default:
            return state;
    }
};
export default tabletReducer;